import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import ContentCombine from "core/Components/ContentCombine";

const ProductItemOutOfStock: React.FC = () => {
    const theme: Theme = useTheme();

    const style = css`
        display: flex;
        justify-content: center;
        margin: 54px auto 0;
        width: 295px;
        height: 49px;
        border-radius: 25px;
        background-color: ${theme.colours.red1};

        ${theme.breakpoints.up('xl')} {
            width: 392px;
        }

        ${theme.breakpoints.only('lg')} {
            margin-top: 52px;
        }

        ${theme.breakpoints.only('md')} {
            margin-top: 34px;
        }

        ${theme.breakpoints.only('sm')} {
            margin-top: 32px;
        }

        ${theme.breakpoints.down('xs')} {
            margin-top: 38px;
        }
    `;

    const textStyle = css`
        font-weight: ${theme.fonts.weights.bold};
        font-size: 21px;
        
        ${theme.breakpoints.down('lg')} {
            font-size: 18px;
        }
    `;

    return (
        <div css={style}>
            <ContentCombine css={textStyle} unsetMinHeight={false}>
                Temporarily out of stock
            </ContentCombine>
        </div>
    );
};

export default ProductItemOutOfStock;
